
import { Info } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

const DemoModeAlert = () => {
  return (
    <Alert className="mb-6 bg-blue-50 border-blue-200">
      <Info className="h-4 w-4 text-blue-500" />
      <AlertTitle className="text-blue-700">Mode Démonstration</AlertTitle>
      <AlertDescription className="text-blue-600">
        Dans cette démo, les invitations sont enregistrées dans la base de données mais 
        <strong> aucun email n'est réellement envoyé</strong> aux destinataires. 
        En production, cette fonctionnalité nécessiterait l'intégration d'un service d'envoi d'emails.
      </AlertDescription>
    </Alert>
  );
};

export default DemoModeAlert;
